import { render } from "./HolidayBanner.vue?vue&type=template&id=6dcca20c&scoped=true"
import script from "./HolidayBanner.vue?vue&type=script&lang=js"
export * from "./HolidayBanner.vue?vue&type=script&lang=js"

import "./HolidayBanner.vue?vue&type=style&index=0&id=6dcca20c&scoped=true&lang=css"

import exportComponent from "/home/twig/Work/FRONT/adsquiz.front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcca20c"]])

export default __exports__